module.exports = __webpack_public_path__ + "img/xiaozi_info.a7612c01.png";